<template>
  <v-container fluid pa-0>
  	<div id="slider-container" :style="{height: (windowHeight - headerHeight - 100 + mobileHeight) + 'px'}">
		
  		<div v-if="windowHeight !== 0 && headerHeight !== 0" class="full-slider-container " style="z-index: -1;">
			<containerGlobo style="position: fixed"/>
  			<div class="full-slider-container mobile" v-if="mobile">
		  		<!-- <div class="image-container link" :style="{'background-image': 'url(' + backgroundImage + ')'}" v-on:click="goTo('mudanza', 'Mudanza_Portada')"></div> -->
		  		<div class="image-container link" :style="{'background-image': 'url(' + backgroundImage + ')'}" @click="goToWS(1)"></div>
				  
				<Selection class="selection-container ml-0"/>
		  	</div>
  			<div class="d-flex full-slider-container" v-else>
				
				<Selection class="selection-container ml-0"/>
				
		  		<div class="image-container link" :style="{'background-image': 'url(' + backgroundImage + ')'}" @click="goToWS(1)"></div>
		  		<!-- <div class="image-container link" :style="{'background-image': 'url(' + backgroundImage + ')'}" v-on:click="goTo('mudanza', 'Mudanza_Portada')"></div> -->
				
		  	</div>
	  	</div>
			<v-layout v-else row wrap my-2 fill-height justify-center align-center>
				<v-flex md12 sm12 xs12 justify-center align-center class="text-xs-center">
					<v-progress-circular
			      :size="50"
			      color="#1f97b9"
			      indeterminate
			    ></v-progress-circular>
			  </v-flex>
			</v-layout>
  	</div>
  </v-container>
</template>
<script>
	import Selection from './SelectionOverSlider'
  import { EventBus } from '../../events.js'
  // import containerGlobo from './Globo'
  export default {
  	name: 'Slider',
  	components: { Selection},
	  data: function() {
	    return {
		  mobileHeight: 0,
	      windowWidth: 0,
	      windowHeight: 0,
	      headerHeight: 0,
	      selectionHeight: 0,
	      mobile: false,
	      backgroundImage: require("../../assets/static/img/portadaNueva4.jpg")
	    }
	  },
	  methods: {
		goToWS(tipo){
			const texto = tipo == 1 ? '¡Hola! Quiero cotizar una mudanza de hogar.' : '¡Hola! Quiero cotizar un flete para Empresa.'
            const url = 'https://wa.me/56996711666?text=' + texto
            const windowOpen = window.open(url)
            windowOpen
        },
		goTo(route, tipo){
			this.eventTracker(tipo)
			this.$router.push({name: route})
		},
		eventTracker(tipo) {
			console.log('entra aqui')
			gtag('event', tipo, {
			'event_category' : tipo,
			'event_label' : tipo
			})
		},
	    getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth
      	this.mobile = false
        if( this.windowWidth < 762 ){
        	this.backgroundImage = require("../../assets/static/img/webp/portadaNuevaMobile2.webp")
			this.mobileHeight = 125
        	this.mobile = true
        } else {
			this.backgroundImage = require("../../assets/static/img/portadaNueva4.jpg")
			this.mobileHeight = 0
        	this.mobile = false
		}
      },
      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight
      }
	  },
	  mounted() {
	    this.$nextTick(function() {
	      window.addEventListener('resize', this.getWindowWidth)
	      window.addEventListener('resize', this.getWindowHeight)
	      this.getWindowWidth()
	      this.getWindowHeight()
	    })
	    this.headerHeight = document.getElementById('fullheader').clientHeight
			EventBus.$on('headHeight', data => {
				this.headerHeight = document.getElementById('fullheader').clientHeight
			})
			EventBus.$on('selectionHeight', data => {
				this.selectionHeight = data
			})
	  },
	  beforeDestroy() {
	    window.removeEventListener('resize', this.getWindowWidth)
	    window.removeEventListener('resize', this.getWindowHeight)
	  }
  }
</script>
<style scoped>
	#slider-container{
		position: relative;
	}
	.image-container{
		min-height: 100px;
	}
	.mobile .image-container{
		width: 100%;
		height: 45%!important;
	}
	.mobile .selection-container{height: 55%!important;}
	.full-slider-container{
		height: 100%;
	}
</style>